import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: "teacher",
    initialState: {
        list: [],
        fetched: false
    },
    reducers: {
        fetchTeacher: (state,action) => {
            state.list = action.payload;
            state.fetched = true;
        },
        newTeacher: (state,action) => {
            state.list.push(action.payload);
        },
        updateTeacher: (state,action) => {
            let teacher = action.payload;
            let index = state.list.findIndex(item=>{
                return item.lecturerId === teacher.lecturerId
            })
            Object.assign( state.list[index], teacher)
        },
        deleteTeacher:(state,action) => {
            let id = action.payload;
            let index = state.list.findIndex(item=>{
                return item.lecturerId === id
            })
            state.list.splice(index,1);
        }
    },
})

export const { fetchTeacher, newTeacher, updateTeacher, deleteTeacher } = slice.actions
export const teacher = slice.reducer